<script lang="ts">
  import { Button } from "$lib/components/ui/button"
  import { MoveRight } from "lucide-svelte"
  import { getRequirement } from "$lib/components/Widget2/utils"
  import { t, getCurrentLanguage } from "$lib/utils/i18n"

  interface Props {
    action: any
    processAction: (action: any) => void
  }

  let { action, processAction }: Props = $props()

  const language = getCurrentLanguage()

  const entries = getRequirement(action, "Entries") || 0

  let entryPluralized = $derived(
    t("widget_action_entries", {
      count: Number(entries),
    }),
  )

  function openTiktokUrl(action) {
    const handle = action.requirements.find((r) => r.name === "Username")?.value
    if (handle.includes("tiktok.com")) {
      window.open(handle, "_blank")
    } else {
      window.open(`https://www.tiktok.com/@${handle}`, "_blank")
    }
  }

  //   onMount(() => {
  //     // Load TikTok embed script
  //     const script = document.createElement("script")
  //     script.src = "https://www.tiktok.com/embed.js"
  //     script.async = true
  //     document.body.appendChild(script)
  //   })
</script>

<div class="bg-white rounded-lg p-4 shadow-lg">
  <div class="mb-4">
    <h4 class="text-sm font-medium mb-2">
      {t("widget_action_worth", { count: entries, entries: entryPluralized })}
    </h4>
  </div>

  <!-- <blockquote
    class="tiktok-embed"
    cite="https://www.tiktok.com/@escapexperience"
    data-unique-id="escapexperience"
    data-embed-type="creator"
    style="max-width: 780px; min-width: 288px;"
  >
    <section>
      <a
        target="_blank"
        href="https://www.tiktok.com/@escapexperience?refer=creator_embed"
        >@escapexperience</a
      >
    </section>
  </blockquote> -->

  <Button
    variant="default"
    class="w-full bg-black text-white hover:bg-gray-800 flex items-center justify-center gap-2"
    onclick={() => {
      openTiktokUrl(action)
      processAction(action)
    }}
  >
    {(action.selectedAction || action.actions)?.translations?.[language]?.name}
    <MoveRight />
  </Button>
</div>
